import {
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
  type CollectionActions,
  type CollectionStateSlice,
} from '@freelancer/datastore/core';
import { transformBusinessBuilderAttempt } from './business-builder-attempt.transformers';
import type { BusinessBuilderAttemptCollection } from './business-builder-attempt.types';

export function businessBuilderAttemptReducer(
  state: CollectionStateSlice<BusinessBuilderAttemptCollection> = {},
  action: CollectionActions<BusinessBuilderAttemptCollection>,
): CollectionStateSlice<BusinessBuilderAttemptCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'businessBuilderAttempt') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<BusinessBuilderAttemptCollection>(
          state,
          transformIntoDocuments(
            result.attempts,
            transformBusinessBuilderAttempt,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'businessBuilderAttempt') {
        const { ref, result } = action.payload;

        return mergeWebsocketDocuments<BusinessBuilderAttemptCollection>(
          state,
          transformIntoDocuments([result], transformBusinessBuilderAttempt),
          ref,
        );
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'businessBuilderAttempt') {
        const { ref, result } = action.payload;

        return mergeWebsocketDocuments<BusinessBuilderAttemptCollection>(
          state,
          transformIntoDocuments([result], transformBusinessBuilderAttempt),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
